// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zopL","col":"styles_col__3XO_M"};